import { AudioElement } from '@app/common';
import DbAudio from './DbAudio';

type Properties = {
    data: AudioElement;
};

const Audio = (props: Properties) => {
    const caption = props.data.caption || '';

    return (
        <div className="page-audio">
            <h2>{caption}</h2>
            <DbAudio 
                autoplay={props.data.autoplay}
                dbId={props.data.id}
                showErrorMessage={true}
            />
        </div>
    );
};
export default Audio;